import {
	HiCog,
	HiCube,
	HiOutlineCurrencyDollar,
	HiOutlineClipboardList,
	HiOutlineViewGrid,
	HiUserGroup,
	HiTrendingUp
} from 'react-icons/hi';
import { HiUserPlus } from 'react-icons/hi2';
import { sidebarMenus } from '../../static/sidebarMenus';
import { useSelector } from 'react-redux';
import { RootState } from '@redux/store';
import { SidebarMenu } from 'react-app-env';
import { NavLink } from 'react-router-dom';
import { useMemo } from 'react';

type Props = {
	closeSidebar: () => void;
}

const Sidebar = ({
	closeSidebar
}: Props) => {
	const { user, isAuthenticated } = useSelector((state: RootState) => state.auth);

	const dataMenu = useMemo((): SidebarMenu[] => {
		let menus: SidebarMenu[] = sidebarMenus;

		if (user?.role) {
			if (user.role !== 'owner') {
				menus = sidebarMenus.filter((item) => item.label.toLocaleLowerCase() !== "dashboard");
			}
		}

		return menus;
	}, [user]);



	return (
		<div className='flex flex-col items-center w-56 h-full overflow-auto text-gray-700 bg-white'>
			<div className='w-full px-2'>
				<div className='flex flex-col items-center w-full border-gray-300'>
					{isAuthenticated
						? dataMenu.map((item, idx) => {
							return (
								<NavLink
									key={`sidebar-menu-${idx}`}
									to={item.path}
									onClick={closeSidebar}
									className={({ isActive }) => {
										let styleColor = 'bg-transparent hover:bg-gray-200';

										if (isActive) {
											styleColor = 'bg-teal-500 text-white';
										}

										return `flex items-center w-full h-12 px-3 mt-2 rounded ${styleColor}`;
									}}
								>
									<span>
										{item.label.toLowerCase() === 'dashboard' ? (
											<HiOutlineViewGrid size={25} />
										) : item.label.toLowerCase() === 'data barang' ? (
											<HiCube size={25} />
										) : item.label.toLowerCase() === 'finance' ? (
											<HiOutlineCurrencyDollar size={25} />
										) : item.label.toLowerCase() === 'jadwal loading' ? (
											<HiOutlineClipboardList size={25} />
										) : item.label.toLowerCase() === 'kinerja' ? (
											<HiTrendingUp size={25} />
										) : item.label.toLowerCase() === 'manpowers' ? (
											<HiUserGroup size={25} />
										) : item.label.toLowerCase() === 'data admin' ? (
											<HiUserPlus size={25} />
										) : item.label.toLowerCase() === 'pengaturan akun' ? (
											<HiCog size={25} />
										) : null}
									</span>
									<span className='ml-3 text-md font-medium'>{item.label}</span>
								</NavLink>
						  )})
						: null}
				</div>
			</div>
		</div>
	);
};

export default Sidebar;
